import { all, call, put, select, take, takeLatest } from 'redux-saga/effects';
import _, { camelCase } from 'lodash';
import {
  buildNewScenario,
  bulkUpdateScenarios as bulkUpdateScenariosAction,
  FETCH_ALL_CHILD_WORKSHEET_SPACES_SUCCESS,
  FETCH_PROJECT_WORKSHEETS_SUCCESS,
  fetchAllChildWorksheetSpaces,
  fetchProjectWorksheets,
  GET_SCENARIOS_SUCCESS,
  getProjectScenarios,
  setCurrentScenario,
  setTemporaryScenario,
} from 'spw-redux/modules/calculators/actions';
import {
  archiveProject as archiveProjectApi,
  bulkUpdateBuildingIndices as bulkUpdateBuildingIndicesApi,
  cloneProject as cloneProjectApi,
  createBuilding as createBuildingApi,
  createNewDepartment as createDepartmentApi,
  createProject as createProjectApi,
  createUserFavoriteProject as createUserFavoriteProjectApi,
  deleteBuilding as deleteBuildingApi,
  deleteBuildingFloor as deleteBuildingFloorApi,
  deleteDepartment as deleteDepartmentApi,
  deleteUserFavoriteProject as deleteUserFavoriteProjectApi,
  fetchProjectColors as fetchProjectColorsApi,
  fetchUserFavoriteProjects as fetchUserFavoriteProjectsApi,
  getDepartmentsByProjectId as getDepartmentsByProjectIdApi,
  getSpaceTypeCategories as getSpaceTypeCategoriesApi,
  getUsersByOrganization as getUsersByOrganizationApi,
  Headcount as headcountApi,
  insertFloorAbove as insertFloorAboveApi,
  insertFloorBelow as insertFloorBelowApi,
  moveFloorDown as moveFloorDownApi,
  moveFloorUp as moveFloorUpApi,
  saveEditingBuilding as saveEditingBuildingApi,
  updateBuildingFloor as updateBuildingFloorApi,
  updateDepartment as updateDepartmentApi,
  updateProject as updateProjectApi,
  updateProjectColors as updateProjectColorsApi,
} from 'spw-api';

import { IAppState } from 'spw-redux/reducer';
import moment from 'moment';
import { findIndex, fromPairs, groupBy, isNil, map, prop, propEq } from 'ramda';
import {
  fetchFloorplanShapes,
  setFloorplan,
} from 'spw-redux/modules/floorplan/actions';
import { actions as ouActions } from 'spw-redux/modules/ou/actions';
import {
  ID_TYPE,
  setSummarySelectedIdType,
} from 'spw-redux/modules/program-summary/actions';
import {
  handleError,
  showToastMessage,
} from 'spw-redux/modules/UI/messages/actions';
import {
  IFloorplan,
  SpaceTypeCategoryMap,
} from 'spw-redux/modules/floorplan/types';
import {
  DEFAULT_COLORS,
  GROWTH_CALCULATORS,
  PRIVATE_OFFICES_SUBCATEGORY,
  PROGRAMMING,
  STANDARD_ERROR_MESSAGE,
  TOTAL_PROGRAM_TYPE,
  WORKSTATIONS_SUBCATEGORY,
} from 'spw-constants';

import { fetchProjectSettings } from 'spw-redux/modules/settings/actions';
import {
  actions as spaceTypeActions,
  FETCH_PROJECT_SPACE_TYPES_SUCCESS,
  fetchProjectSpaceTypesSuccess,
} from 'spw-redux/modules/space_types/actions';
import { camelCaseSpaceTypeCategories } from 'spw-redux/modules/project-space-type-categories/utils';
import {
  IProjectSpaceType,
  ISpaceTypeCategory,
  SpaceTypeColor,
} from 'spw-redux/modules/space_types/types';
import { APIResponse } from 'spw-redux/types';
import { isDepartmentScenario } from 'spw-components/worksheet/utils';
import { buildingIndexesById } from 'spw-redux/modules/projects/utils';
import { selectAreaUnit } from 'spw-components/unit-conversion/selectors';
import {
  updateSelectedProjectColorsApi,
  addProjectEditor,
  addTeamToProject,
  getProjectEditors as getProjectEditorsApi,
  getProjectInfoById as getProjectInfoByIdApi,
  getProjects as getProjectsApi,
  issueRequestToJoinProject as issueRequestToJoinProjectApi,
  joinProject as joinProjectApi,
  leaveProject,
  recordProjectActivity as recordProjectActivityApi,
  removeProjectEditor,
  removeTeamFromProject,
  transferProjectOwnership,
} from 'spw-api/projects';
import { selectProjectSpaceTypes } from 'spw-redux/modules/space_types/selectors';
import {
  Actions,
  actions,
  ADD_PROJECT_EDITORS,
  ADD_TEAMS_TO_PROJECT,
  addTeamsToProject,
  ARCHIVE_PROJECT,
  BULK_UPDATE_BUILDING_INDICES,
  CLONE_PROJECT,
  cloneProject as cloneProjectAction,
  CREATE_USER_FAVORITE_PROJECT,
  DELETE_BUILDING,
  DELETE_BUILDING_FLOOR,
  DELETE_DEPARTMENT,
  DELETE_USER_FAVORITE_PROJECT,
  DELETE_USER_FAVORITE_PROJECT_LEGACY,
  FETCH_PROJECT_COLORS,
  GET_DEPARTMENTS_BY_PROJECT_ID,
  GET_ORGANIZATION_USERS,
  GET_PROJECT_EDITORS,
  GET_PROJECT_INFO_BY_ID,
  GET_PROJECTS,
  GET_SPACE_TYPE_CATEGORIES,
  GET_USER_FAVORITE_PROJECTS_LEGACY,
  getOrganizationUsersSucceeded,
  getProjectEditors,
  getProjectInfoById,
  getSpaceTypeCategories as getSpaceTypeCategoriesAction,
  getUserFavoriteProjectsLegacy as getUserFavoriteProjectsLegacyAction,
  getUserFavoriteProjectsLegacySucceeded,
  INSERT_FLOOR_ABOVE,
  INSERT_FLOOR_BELOW,
  ISSUE_REQUEST_TO_JOIN_PROJECT,
  issueRequestToJoinProject,
  JOIN_CURRENT_PROJECT,
  JOIN_PROJECT,
  LEAVE_PROJECT,
  MOVE_FLOOR_DOWN,
  MOVE_FLOOR_UP,
  RECORD_PROJECT_ACTIVITY,
  REFRESH_CURRENT_PROJECT,
  REMOVE_PROJECT_EDITOR,
  REMOVE_TEAM_FROM_PROJECT,
  SAVE_BUILDING,
  SAVE_DEPARTMENT,
  SAVE_EDITING_BUILDING,
  SAVE_PROJECT,
  SAVE_PROJECT_YEAR,
  saveProject,
  SET_PROJECT_COLOR,
  setCurrentBuilding,
  setCurrentFloor,
  setCurrentProject,
  TRANSFER_PROJECT_OWNERSHIP,
  UPDATE_BUILDING_FLOOR,
  UPDATE_DEPARTMENT,
  UPDATE_DEPARTMENTS,
  UPDATE_HEADCOUNTS,
  UPDATE_LAST_EDITOR_WITH_CURRENT_USER,
  UPDATE_PROJECT_COLORS,
  UPDATE_PROJECT_HEADCOUNT_TYPE,
  updateDepartmentsSuccess,
  updateProjectYear,
} from './actions';

import { camelize, replaceAtIndex } from '../../../shared/utils';
import {
  buildingLevel,
  floorLevel,
  Headcount,
  IBuilding,
  IDepartment,
  IFloor,
  IProject,
  IProjectColors,
  IProjectSpaceTypeSubcategory,
  UserRoleInProject,
} from './types';
import { ICategory } from '../program-summary/types';
import {
  currentFloor as selectCurrentFloor,
  currentProject as selectCurrentProject,
  projectColors as selectProjectColors,
  projectColors as projectColorsSelect,
  projectSpaceTypes as projectSpaceTypesSelector,
  selectFirstBuilding,
} from './selectors';
import { selectCurrentOrganization } from '../organization/selectors';
import {
  selectCurrentScenario,
  selectScenarios,
  selectTemporaryScenario,
  selectWorksheet,
  selectWorksheets,
} from '../calculators/selectors';
import ProgramScenario, {
  PlainProgramScenario,
} from '../../../models/Scenario';
import ProgramScenarioFactory from '../../../models/ProgramScenarioFactory';
import { PlainWorksheet } from '../../../models/Worksheet';
import { Organization } from '../organization/types';
import { getUserPendingProjectRequests } from '../join-requests/actions';
import { getTeamsForProject } from '../teams/actions';
import { currentUser as selectCurrentUser } from '../user/selectors';
import { IUser } from '../user/types';
import { Scenario } from '../calculators/types';
import { getMissingData } from '../benchmark-reports/actions';

export const getCurrentProject = (state: IAppState) =>
  state.projectsReducer.currentProject;

export const getCurrentBuilding = (state: IAppState) =>
  state.projectsReducer.currentBuilding;

function* archiveProject(action: Actions) {
  try {
    if (action?.type !== ARCHIVE_PROJECT) {
      return;
    }
    const { project } = action.payload;
    yield call(archiveProjectApi, project);
    if (action.payload.onArchiveSucceeded) action.payload.onArchiveSucceeded();
    if (action.payload.shouldRefreshProjectsAfterwards)
      yield put(actions.getProjects({ type: project.type }));
  } catch (e) {
    yield put(handleError(e));
  }
}

function* cloneProject(action: ReturnType<typeof cloneProjectAction>) {
  const {
    createdByUserId,
    projectId,
    projectName,
    client,
    city,
    state,
    countryCode,
    projectNumber,
    status,
    requiresRequestToJoin,
    selectedBuildingIds,
    onCloneSucceeded,
  } = action.payload;

  try {
    yield put(actions.setCloningProjectId(projectId));
    const {
      data: {
        clone_project: { id: clonedProjectId },
      },
    }: // eslint-disable-next-line camelcase
    { data: { clone_project: { id: number } } } = yield call(cloneProjectApi, {
      createdByUserId,
      projectId,
      projectName,
      clientId: client.id,
      city,
      state,
      countryCode,
      projectNumber,
      status,
      requiresRequestToJoin,
      selectedBuildingIds,
    });
    if (clonedProjectId && onCloneSucceeded) onCloneSucceeded(clonedProjectId);

    yield all([
      put(actions.getUserFavoriteProjectsLegacy(PROGRAMMING)),
      put(actions.getProjects({ type: PROGRAMMING })),
      put(actions.setCloningProjectId(null)),
      put(actions.setCurrentBuilding(null)),
    ]);
  } catch (e) {
    yield all([put(handleError(e)), put(actions.setCloningProjectId(null))]);
  }
}

function* saveProjectCall(action: ReturnType<typeof saveProject>) {
  try {
    const { project, onSaveSucceeded } = action.payload;
    let projectResponse: APIResponse<typeof createProjectApi>;
    let receivedProject: IProject;

    if (!project.id) {
      projectResponse = yield call(createProjectApi, project);
      receivedProject = camelize(projectResponse.data.create_project);
    } else {
      projectResponse = yield call(updateProjectApi, project);

      receivedProject = camelize(projectResponse.data.updatedProject);
      if (onSaveSucceeded && receivedProject?.id) {
        onSaveSucceeded(receivedProject.id);
      }
    }

    yield put(
      actions.saveProjectSucceeded({
        ...receivedProject,
        spaceTypeCategories: camelCaseSpaceTypeCategories(
          receivedProject.spaceTypeCategories
        ),
      })
    );
    if (onSaveSucceeded && receivedProject?.id)
      onSaveSucceeded(receivedProject.id);
  } catch (e) {
    yield put(handleError(e));
  }
}

function* saveBuilding(action: ReturnType<typeof actions.saveBuilding>) {
  try {
    const { building } = action.payload;
    const buildingResponse: APIResponse<typeof createBuildingApi> = yield call(
      createBuildingApi,
      building
    );

    const receivedBuildings = buildingResponse.data.buildings;
    yield put(actions.updateProjectBuildingsSucceeded(receivedBuildings));
    yield put(actions.getProjectInfoById(building.projectId));
  } catch (e) {
    yield put(handleError(e));
  }
}

function* saveEditingBuilding(
  action: ReturnType<typeof actions.saveEditingBuilding>
) {
  try {
    const { building } = action.payload;
    const currentBuilding: IBuilding = yield select(getCurrentBuilding);
    const currentProject: IProject = yield select(selectCurrentProject);
    const updatedBuilding: IBuilding & { id?: number; projectId: number } = {
      ...currentBuilding,
      ...building,
      projectId:
        building.projectId || currentBuilding.projectId || currentProject.id,
    };
    const buildingResponse: APIResponse<typeof saveEditingBuildingApi> = yield call(
      saveEditingBuildingApi,
      updatedBuilding
    );

    const receivedBuildings = buildingResponse.data.buildings;

    if (currentBuilding) {
      const updatedCurrentBuilding = receivedBuildings.find(
        (receivedBuilding: IBuilding) =>
          receivedBuilding.id === currentBuilding.id
      );

      if (updatedCurrentBuilding) {
        yield put(actions.updateCurrentBuilding(updatedCurrentBuilding));
      }
    }

    yield put(actions.updateProjectBuildingsSucceeded(receivedBuildings));

    const isProgrammingProject = currentProject.type === 'programming';
    const haveUSFBeenUpdated =
      !isNil(building.programmingUsf) &&
      currentBuilding?.programmingUsf !== building?.programmingUsf;

    if (isProgrammingProject && haveUSFBeenUpdated) {
      const scenarios: PlainProgramScenario[] = yield select(selectScenarios);

      const buildingUSFScenariosToUpdate = scenarios.filter(
        (s) => s.calculatorType === GROWTH_CALCULATORS.buildingUsf
      );

      const scenarioBeforeUSFUpdate: ProgramScenario = yield select(
        selectCurrentScenario
      );

      if (
        scenarioBeforeUSFUpdate &&
        scenarioBeforeUSFUpdate.calculatorType !== TOTAL_PROGRAM_TYPE
      ) {
        yield put(
          setCurrentScenario({
            ...ProgramScenario.toAPIScenario(scenarioBeforeUSFUpdate),
            building: updatedBuilding,
          })
        );
      }
      yield put(
        fetchProjectWorksheets(buildingUSFScenariosToUpdate.map((s) => s.id))
      );
      yield take(FETCH_PROJECT_WORKSHEETS_SUCCESS);
      const worksheets: PlainWorksheet[] = yield select(selectWorksheets);

      const scenariosWithOldUSFPersisted = buildingUSFScenariosToUpdate.map(
        (s) => {
          const scenarioWorksheet = worksheets?.find(
            (ws) => ws.scenario?.id === s.id
          );
          const worksheetHasAtLeastOneRowWithQty = !!scenarioWorksheet?.hasAtLeastOneRowWithQuantity;
          const workSeatsAfterUSFChange = ProgramScenarioFactory.create({
            ...ProgramScenario.toAPIScenario(s),
            building: updatedBuilding,
          }).workSeats;
          const workSeatsBeforeUSFChange = worksheetHasAtLeastOneRowWithQty
            ? s.storedWorkSeats || s.workSeats
            : null;

          const areStoredWorkSeatsOutdated =
            worksheetHasAtLeastOneRowWithQty &&
            workSeatsAfterUSFChange !== workSeatsBeforeUSFChange;
          return {
            ...ProgramScenario.toAPIScenario(s),
            building: updatedBuilding,
            storedWorkSeats: areStoredWorkSeatsOutdated
              ? workSeatsBeforeUSFChange
              : null,
            areStoredWorkSeatsOutdated,
          };
        }
      );
      const currentWorksheet: PlainWorksheet = yield select(selectWorksheet);
      if (
        scenarioBeforeUSFUpdate?.calculatorType ===
          GROWTH_CALCULATORS.buildingUsf &&
        currentWorksheet
      ) {
        const workSeatsBeforeUSFChange = currentWorksheet?.hasAtLeastOneRowWithQuantity
          ? scenarioBeforeUSFUpdate.storedWorkSeats ||
            scenarioBeforeUSFUpdate.workSeats
          : null;
        yield put(
          setCurrentScenario({
            ...ProgramScenario.toAPIScenario(scenarioBeforeUSFUpdate),
            building: updatedBuilding,
            areStoredWorkSeatsOutdated:
              currentWorksheet.hasAtLeastOneRowWithQuantity,
            storedWorkSeats: workSeatsBeforeUSFChange,
          })
        );
      }
      yield put(bulkUpdateScenariosAction(scenariosWithOldUSFPersisted));
    }

    yield put(actions.getProjectInfoById(updatedBuilding.projectId));
  } catch (e) {
    yield put(handleError(e));
  }
}

function* deleteBuilding(action: ReturnType<typeof actions.deleteBuilding>) {
  try {
    const { buildingId } = action.payload;
    const project: IProject = yield select(selectCurrentProject);
    const buildingResponse: APIResponse<typeof deleteBuildingApi> = yield call(
      deleteBuildingApi,
      buildingId
    );
    const deletedBuilding = buildingResponse.data.deleteBuilding;

    const { buildings } = yield select(getCurrentProject);
    const updatedBuildings = buildings.filter(
      (b: IBuilding) => b.id !== deletedBuilding.id
    );
    yield put(actions.updateProjectBuildingsSucceeded(updatedBuildings));
    yield put(setCurrentBuilding(undefined));
    yield put(getMissingData(project.id));

    if (buildings) {
      yield put(setSummarySelectedIdType(buildings[0].id, ID_TYPE.buildingId));
    }
  } catch (e) {
    yield put(handleError(e));
  }
}

function* bulkUpdateBuildingIndices(
  action: ReturnType<typeof actions.bulkUpdateBuildingIndices>
) {
  try {
    const currentProject: IProject = yield select(selectCurrentProject);
    const { buildings } = action.payload;

    // Optimistically update the order with the new indices
    yield put(actions.updateProjectBuildingsSucceeded(buildings));

    // Commit the change to the backend
    yield call(
      bulkUpdateBuildingIndicesApi,
      buildings.map(
        (b) => ({ id: b.id, index: b.index } as Pick<IBuilding, 'id' | 'index'>)
      )
    );

    // Re-fetch project information that might have been affected by the new indices
    yield all([
      put(getProjectInfoById(currentProject.id)),
      put(ouActions.fetchProjectsRounds(currentProject.id)),
    ]);
  } catch (e) {
    yield put(handleError(e));
  }
}

function* updateCurrentProjectBuilding(building: IBuilding) {
  try {
    const currentProject: IProject = yield select(selectCurrentProject);
    const index = findIndex(propEq('id', building.id))(
      currentProject.buildings as { id: number }[]
    );

    const buildings = currentProject.buildings.slice();
    buildings[index] = building;

    yield put(actions.setCurrentProject({ ...currentProject, buildings }));
  } catch (e) {
    yield put(handleError(e));
  }
}

function* getProjects(action: ReturnType<typeof actions.getProjects>) {
  try {
    const projectResponse: APIResponse<typeof getProjectsApi> = yield call(
      getProjectsApi,
      action.payload
    );

    const {
      projects: { projects, total },
    } = projectResponse.data;

    projects.forEach((project: IProject) => ({
      ...project,
      insertedAt: moment.utc(project.insertedAt, 'YYYY-MM-DD HH:mm:ss').local(),
    }));

    yield put(
      actions.getProjectsSucceeded({ projects, totalFilteredProjects: total })
    );
  } catch (e) {
    yield put(handleError(e));
  }
}

function* refreshCurrentProjectCall() {
  try {
    const currentProject: IProject = yield select(getCurrentProject);
    const currentBuilding: IBuilding = yield select(getCurrentBuilding);
    const currentFloor: IFloor = yield select(selectCurrentFloor);
    if (!currentProject?.id) return;
    const projectResponse: APIResponse<typeof getProjectInfoByIdApi> = yield call(
      getProjectInfoByIdApi,
      currentProject.id
    );

    const { project }: { project: IProject } = projectResponse.data;

    yield put(
      actions.setCurrentProject({
        ...project,
        spaceTypeCategories: camelCaseSpaceTypeCategories(
          project.spaceTypeCategories
        ),
      })
    );

    const freshCurrentBuilding = project.buildings?.find(
      ({ id }) => id === currentBuilding?.id
    );
    const freshCurrentFloor = freshCurrentBuilding?.floors.find(
      ({ id }) => id === currentFloor?.id
    );

    if (freshCurrentBuilding) {
      const indexOfFloor = currentBuilding.floors?.findIndex(
        ({ id }) => id === currentFloor?.id
      );
      const newCurrentBuilding = {
        ...currentBuilding,
      };
      newCurrentBuilding.floors[indexOfFloor] = {
        ...freshCurrentFloor,
      };
      yield put(actions.setCurrentBuilding(newCurrentBuilding));
    }

    if (freshCurrentFloor) {
      yield put(actions.setCurrentFloor(freshCurrentFloor));
    }
  } catch (error) {
    yield put(handleError(error));
  }
}

function* getProjectById(
  action: ReturnType<typeof actions.getProjectInfoById>
) {
  try {
    const projectResponse: APIResponse<typeof getProjectInfoByIdApi> = yield call(
      getProjectInfoByIdApi,
      action.payload.projectId
    );

    const { project }: { project: IProject } = projectResponse.data;

    yield put(
      actions.getProjectInfoByIdSucceeded({
        ...project,
        spaceTypeCategories: camelCaseSpaceTypeCategories(
          project.spaceTypeCategories
        ),
      })
    );

    if (project.archived) return;
    yield put(actions.fetchProjectColors());
    yield put(actions.getDepartmentsByProjectId(project.id));
    yield put(spaceTypeActions.fetchProjectSpaceTypes());

    if (project?.type === PROGRAMMING) {
      yield put(fetchProjectSettings());
    }
    // don't move this before yield put(spaceTypeActions.fetchProjectSpaceTypes());
    // otherwise child spaces may not populate in programming
    yield put(getSpaceTypeCategoriesAction());
  } catch (error) {
    yield put(handleError(error));
  }
}

function* getDepartmentsByProjectId(
  action: ReturnType<typeof actions.getDepartmentsByProjectId>
) {
  try {
    const departmentsResponse: APIResponse<typeof getDepartmentsByProjectIdApi> = yield call(
      getDepartmentsByProjectIdApi,
      action.payload.projectId
    );

    const { departmentsByProjectId: departments } = departmentsResponse.data;

    yield put(actions.getDepartmentsByProjectIdSucceeded(departments.slice()));
    yield put(actions.updateNumberOfDepartments(departments?.length || 0));
  } catch (e) {
    yield put(handleError(e));
  }
}

function* updateDepartment(
  action: ReturnType<typeof actions.updateDepartment>
) {
  try {
    const departmentResponse: APIResponse<typeof updateDepartmentApi> = yield call(
      updateDepartmentApi,
      action.payload.department
    );
    const { projectId } = departmentResponse.data.updateDepartment;
    yield put(actions.getDepartmentsByProjectId(projectId));
    yield put(
      showToastMessage({
        status: 'success',
        text: 'The department was successfully saved!',
      })
    );
  } catch (e) {
    yield put(handleError(e));
  }
}

function* updateDepartments(
  action: ReturnType<typeof actions.updateDepartments>
) {
  try {
    const { departments } = action.payload;
    const updates = departments.map((department: IDepartment) => {
      return call(updateDepartmentApi, department);
    });

    yield all(updates);

    yield put(updateDepartmentsSuccess(departments));
  } catch (e) {
    yield put(handleError(e));
  }
}

function* createDepartment(action: ReturnType<typeof actions.saveDepartment>) {
  try {
    const { department } = action.payload;
    const departmentResponse: APIResponse<typeof createDepartmentApi> = yield call(
      createDepartmentApi,
      department
    );

    const { projectId } = departmentResponse.data.createNewDepartment;
    yield put(actions.getDepartmentsByProjectId(projectId));
    yield put(
      showToastMessage({
        status: 'success',
        text: 'The department was successfully saved!',
      })
    );
  } catch (e) {
    yield put(handleError(e));
  }
}

function* deleteDepartment(
  action: ReturnType<typeof actions.deleteDepartment>
) {
  try {
    const { departmentId } = action.payload;
    const currentProject: IProject = yield select(selectCurrentProject);
    if (currentProject.type === PROGRAMMING) {
      const currentScenario: PlainProgramScenario = yield select(
        selectCurrentScenario
      );
      if (
        isDepartmentScenario(currentScenario) &&
        currentScenario.department.id === departmentId
      ) {
        yield put(setCurrentScenario(null));
      }
    }

    const departmentResponse: APIResponse<typeof deleteDepartmentApi> = yield call(
      deleteDepartmentApi,
      departmentId
    );
    const { projectId } = departmentResponse.data.deleteDepartment;

    yield put(actions.getDepartmentsByProjectId(projectId));
    yield put(getProjectScenarios(projectId));
    yield put(
      showToastMessage({
        status: 'success',
        text: 'The department was successfully deleted!',
      })
    );
  } catch (e) {
    yield put(handleError(e));
  }
}

function* getSpaceTypeCategories() {
  try {
    const project: IProject = yield select(getCurrentProject);
    if (project) {
      const spaceCategoriesResponse: APIResponse<typeof getSpaceTypeCategoriesApi> = yield call(
        getSpaceTypeCategoriesApi,
        project.id
      );

      let spaceTypeCategories = camelize(
        spaceCategoriesResponse.data.spaceTypeCategories
      );

      spaceTypeCategories = map(
        (c) => ({ ...c, category: camelCase(c.category) }),
        spaceTypeCategories
      ) as ICategory[];

      /* New subcategories were created (private offices and workstations).
         They are filtered out when the type of the project is not programming because this change might affect ESA projects. */
      spaceTypeCategories =
        project.type === PROGRAMMING
          ? spaceTypeCategories
          : spaceTypeCategories.filter(
              (stc: ISpaceTypeCategory) =>
                ![
                  PRIVATE_OFFICES_SUBCATEGORY,
                  WORKSTATIONS_SUBCATEGORY,
                ].includes(stc.category)
            );

      const spaceTypeCategoriesMapArray = groupBy(
        prop('category'),
        spaceTypeCategories
      );

      const spaceTypeCategoriesMap = fromPairs(
        Object.keys(spaceTypeCategoriesMapArray).map((key) => [
          key,
          spaceTypeCategoriesMapArray[key][0],
        ])
      ) as SpaceTypeCategoryMap;

      /* can probably remove this block of code and refactor getProjectById to not call getSpaceCategories for PROGRAMMING */
      if (project.type === PROGRAMMING) {
        const projectSpaceTypes: IProjectSpaceType[] = yield select(
          projectSpaceTypesSelector
        );
        if (!projectSpaceTypes?.length) {
          yield put(spaceTypeActions.fetchProjectSpaceTypes());
          yield take(FETCH_PROJECT_SPACE_TYPES_SUCCESS);
        }
        yield put(fetchAllChildWorksheetSpaces());
        // needs to only occur on programming type projs
        yield take(FETCH_ALL_CHILD_WORKSHEET_SPACES_SUCCESS);
      }

      yield put(
        actions.getSpaceTypeCategoriesSucceeded(
          spaceTypeCategories,
          spaceTypeCategoriesMap
        )
      );
    }
  } catch (e) {
    yield put(handleError(e));
  }
}

function* updateBuildingFloor(
  action: ReturnType<typeof actions.updateBuildingFloor>
) {
  try {
    const { floor, blockRedirect, updatesUsf } = action.payload;
    const currentBuilding: IBuilding = yield select(selectFirstBuilding);
    const areaUnit: string = yield select(selectAreaUnit);
    const buildingResponse: APIResponse<typeof updateBuildingFloorApi> = yield call(
      updateBuildingFloorApi,
      floor,
      updatesUsf
    );
    const building = buildingResponse.data.updatedBuilding;
    if (floor.deleteShape) {
      yield put(fetchFloorplanShapes());
    }

    if (updatesUsf) {
      yield put(
        showToastMessage({
          text: `Floor ${areaUnit} saved successfully!`,
          status: 'success',
        })
      );
    }

    const currentFloorplan: IFloorplan = yield select(
      (state: IAppState) => state.floorplanReducer.currentFloorplan
    );

    yield call(updateCurrentProjectBuilding, building);

    if (!blockRedirect) {
      const currentFloor: IFloor = yield select(selectCurrentFloor);
      yield put(setCurrentBuilding(building, true));
      yield put(
        setCurrentFloor({
          ...floor,
          totalFloorUsf: floor.totalFloorUsf || currentFloor.totalFloorUsf,
        })
      );
    }

    yield put(setFloorplan(currentFloorplan));
    const currentProject: IProject = yield select(selectCurrentProject);

    yield put(getProjectInfoById(currentProject.id));

    const isProgrammingProject = currentProject.type === 'programming';
    if (isProgrammingProject) {
      const currentFloor = currentBuilding.floors.find(
        (f) => f.id === floor.id
      );
      const haveFloorUSFChanged =
        floor.totalFloorUsf &&
        floor.totalFloorUsf !== currentFloor.totalFloorUsf;

      const scenarioBeforeUSFUpdate: ProgramScenario = yield select(
        selectCurrentScenario
      );

      if (
        scenarioBeforeUSFUpdate &&
        scenarioBeforeUSFUpdate.calculatorType === 'floor-usf'
      ) {
        yield put(
          setCurrentScenario({
            ...ProgramScenario.toAPIScenario(scenarioBeforeUSFUpdate),
            building,
          })
        );
      }

      if (!haveFloorUSFChanged) return;
      const scenarios: PlainProgramScenario[] = yield select(selectScenarios);

      const floorScenariosToUpdate = scenarios.filter(
        (s) =>
          s.floorId === floor.id &&
          s.calculatorType === GROWTH_CALCULATORS.floorUsf
      );
      yield put(
        fetchProjectWorksheets(floorScenariosToUpdate.map((s) => s.id))
      );
      yield take(FETCH_PROJECT_WORKSHEETS_SUCCESS);
      const worksheets: PlainWorksheet[] = yield select(selectWorksheets);

      const floorScenariosWithOldUSFPersisted = floorScenariosToUpdate.map(
        (s) => {
          const scenarioWorksheet = worksheets?.find(
            (ws) => ws.scenario?.id === s.id
          );
          const workSeatsAfterUSFChange = ProgramScenarioFactory.create({
            ...ProgramScenario.toAPIScenario(s),
            building,
          }).workSeats;
          const workSeatsBeforeUSFChange = scenarioWorksheet?.hasAtLeastOneRowWithQuantity
            ? s.storedWorkSeats || s.workSeats
            : null;
          const areStoredWorkSeatsOutdated =
            scenarioWorksheet?.hasAtLeastOneRowWithQuantity &&
            workSeatsAfterUSFChange !== workSeatsBeforeUSFChange;
          return {
            ...ProgramScenario.toAPIScenario(s),
            building,
            storedWorkSeats: areStoredWorkSeatsOutdated
              ? workSeatsBeforeUSFChange
              : null,
            areStoredWorkSeatsOutdated,
          };
        }
      );

      yield put(bulkUpdateScenariosAction(floorScenariosWithOldUSFPersisted));
      const currentWorksheet: PlainWorksheet = yield select(selectWorksheet);
      if (
        scenarioBeforeUSFUpdate?.calculatorType ===
          GROWTH_CALCULATORS.floorUsf &&
        currentWorksheet
      ) {
        const workSeatsBeforeUSFChange = currentWorksheet.hasAtLeastOneRowWithQuantity
          ? scenarioBeforeUSFUpdate.storedWorkSeats ||
            scenarioBeforeUSFUpdate.workSeats
          : null;
        // Only update the current scenario if it's within the updated floor
        if (scenarioBeforeUSFUpdate.floorId === floor.id) {
          yield put(
            setCurrentScenario({
              ...ProgramScenario.toAPIScenario(scenarioBeforeUSFUpdate),
              building,
              areStoredWorkSeatsOutdated: !!workSeatsBeforeUSFChange,
              storedWorkSeats: workSeatsBeforeUSFChange,
            })
          );
        }
      }
    }
  } catch (e) {
    yield put(handleError(e));
  }
}

function* deleteBuildingFloor(
  action: ReturnType<typeof actions.deleteBuildingFloor>
) {
  try {
    const { floor, redirect } = action.payload;
    const project: IProject = yield select(selectCurrentProject);
    const buildingResponse: APIResponse<typeof deleteBuildingFloorApi> = yield call(
      deleteBuildingFloorApi,
      floor
    );

    const { building } = buildingResponse.data;

    yield call(updateCurrentProjectBuilding, building);
    yield put(setCurrentBuilding(building));

    const reassignFloor = building.floors.findIndex(
      (floors: any) => floors.floorNumber === floor.floorNumber
    );

    let currentFloor;
    if (building.floors && reassignFloor === -1) {
      [currentFloor] = building.floors;
    } else if (building.floors) {
      currentFloor = building.floors[reassignFloor];
    }

    const { buildings } = project;
    const buildingIndex = buildings.findIndex((b) => b.id === building.id);

    yield put(
      setCurrentProject({
        ...project,
        buildings: replaceAtIndex(buildings, building, buildingIndex),
      })
    );
    yield put(getMissingData(project.id));

    if (redirect) {
      redirect(currentFloor, true);
    } else {
      yield put(setCurrentFloor(currentFloor));
    }
  } catch (e) {
    yield put(handleError(e));
  }
}

function* insertFloorAbove(
  action: ReturnType<typeof actions.insertFloorAbove>
) {
  try {
    const { floor, redirect } = action.payload;
    const buildingResponse: APIResponse<typeof insertFloorAboveApi> = yield call(
      insertFloorAboveApi,
      floor
    );
    const building = buildingResponse.data.insertFloorAbove;
    yield call(updateCurrentProjectBuilding, building);
    yield put(setCurrentBuilding(building, true));
    const floorAbovePosition =
      building.floors.findIndex((floors: any) => floors.id === floor.id) - 1;
    const floorAbove = building.floors[floorAbovePosition];
    if (redirect) {
      redirect(floorAbove);
    } else {
      yield put(setCurrentFloor(floorAbove));
    }
  } catch (e) {
    yield put(handleError(e));
  }
}

function* insertFloorBelow(
  action: ReturnType<typeof actions.insertFloorBelow>
) {
  try {
    const { floor, redirect } = action.payload;
    const buildingResponse: APIResponse<typeof insertFloorBelowApi> = yield call(
      insertFloorBelowApi,
      floor
    );
    const building = buildingResponse.data.insertFloorBelow;

    yield call(updateCurrentProjectBuilding, building);
    yield put(setCurrentBuilding(building, true));
    const floorBelowPosition =
      building.floors.findIndex((floors: any) => floors.id === floor.id) + 1;
    const floorBelow = building.floors[floorBelowPosition];
    if (redirect) {
      redirect(floorBelow);
    } else {
      yield put(setCurrentFloor(floorBelow));
    }
  } catch (e) {
    yield put(handleError(e));
  }
}

function* moveFloorUp(action: ReturnType<typeof actions.moveFloorUp>) {
  try {
    const { floor } = action.payload;
    const buildingResponse: APIResponse<typeof moveFloorUpApi> = yield call(
      moveFloorUpApi,
      floor
    );
    const building = buildingResponse.data.moveFloorUp;
    yield call(updateCurrentProjectBuilding, building);
    yield put(setCurrentBuilding(building, true));
    yield put(setCurrentFloor(floor));
  } catch (e) {
    yield put(handleError(e));
  }
}

function* moveFloorDown(action: ReturnType<typeof actions.moveFloorDown>) {
  try {
    const { floor } = action.payload;
    const buildingResponse: APIResponse<typeof moveFloorDownApi> = yield call(
      moveFloorDownApi,
      floor
    );
    const building = buildingResponse.data.moveFloorDown;
    yield call(updateCurrentProjectBuilding, building);
    yield put(setCurrentBuilding(building));
    yield put(setCurrentFloor(floor));
  } catch (e) {
    yield put(handleError(e));
  }
}

function* fetchProjectColors() {
  try {
    const project: IProject = yield select(selectCurrentProject);
    const organization: Organization = yield select(selectCurrentOrganization);
    const organizationColors = _.omit(organization?.organizationColors, 'id');
    const defaultColors = !_.isEmpty(organizationColors)
      ? organizationColors
      : DEFAULT_COLORS;

    const response: APIResponse<typeof fetchProjectColorsApi> = yield call(
      fetchProjectColorsApi,
      project?.id
    );

    let projectColors = response?.data?.projectColors;

    if (_.isEmpty(projectColors)) {
      projectColors = defaultColors;
    }

    const colors = { ...defaultColors, ...projectColors };

    yield put(actions.fetchProjectColorsSucceeded(colors));
  } catch (e) {
    yield put(handleError(e));
  }
}

function* setProjectColors(action: ReturnType<typeof actions.setProjectColor>) {
  try {
    const oldColors: IProjectColors = yield select(projectColorsSelect);
    const organization: Organization = yield select(selectCurrentOrganization);
    const defaultColors = organization?.organizationColors || DEFAULT_COLORS;
    const project: IProject = yield select(selectCurrentProject);

    const { projectColors } = action.payload;

    const newColors = _.omit(
      {
        ...oldColors,
        ...projectColors,
        projectId: project?.id,
      },
      'otherSpaces'
    ) as IProjectColors;

    const response: APIResponse<typeof updateProjectColorsApi> = yield call(
      updateProjectColorsApi,
      newColors
    );

    const updatedProjectColors = response?.data?.projectColors;
    const colors = { ...defaultColors, ...updatedProjectColors };
    yield put(actions.fetchProjectColorsSucceeded(colors));
    yield put(spaceTypeActions.fetchProjectSpaceTypes());
  } catch (e) {
    yield put(handleError(e));
  }
}

function* updateProjectColors(
  action: ReturnType<typeof actions.updateProjectColors>
) {
  try {
    const project: IProject = yield select(selectCurrentProject);
    const projectSpaceTypes: IProjectSpaceType[] = yield select(
      selectProjectSpaceTypes
    );
    const { projectColors } = action.payload;
    const { subcategoryColors, spaceTypeColors } = projectColors;
    const { spaceTypeCategories } = project;
    const subcategories = spaceTypeCategories.reduce(
      (allSubcategories, spaceTypeCategory) => {
        return allSubcategories.concat(spaceTypeCategory.subcategories);
      },
      []
    );
    const subcategoriesMap: Record<
      number,
      IProjectSpaceTypeSubcategory
    > = subcategories.reduce((subcategoriesById, subcategory) => {
      return { ...subcategoriesById, [subcategory.id]: subcategory };
    }, []);

    const {
      data: { updatedProjectColors },
    }: APIResponse<typeof updateSelectedProjectColorsApi> = yield call(
      updateSelectedProjectColorsApi,
      project.id,
      {
        subcategoryColors,
        spaceTypeColors,
      }
    );

    const updatedSubcategoryColors = (
      updatedProjectColors.subcategoryColors || []
    ).reduce((colorsBySubcategory, subcategoryColor) => {
      const subcategory = subcategoriesMap[subcategoryColor.id];
      const defaultCategory = subcategory.defaultSpaceTypeCategory.category;

      return {
        ...colorsBySubcategory,
        [defaultCategory]: subcategoryColor.color,
        [`${defaultCategory}GradientColorIndex`]: subcategoryColor.gradientColorIndex,
      };
    }, {});

    const updatedSpaceTypeColors: Record<number, SpaceTypeColor> = (
      updatedProjectColors.spaceTypeColors || []
    ).reduce((spaceTypeColorsById, spaceTypeColor) => {
      return {
        ...spaceTypeColorsById,
        [spaceTypeColor.id]: spaceTypeColor,
      };
    }, {});

    const currentProjectColors: IProjectColors = yield select(
      selectProjectColors
    );

    yield put(
      actions.fetchProjectColorsSucceeded({
        ...currentProjectColors,
        ...updatedSubcategoryColors,
      })
    );

    if (updatedSpaceTypeColors) {
      const updatedProjectSpaceTypes = projectSpaceTypes.map(
        (projectSpaceType: IProjectSpaceType) => {
          const spaceTypeColor = updatedSpaceTypeColors[projectSpaceType.id];
          return { ...projectSpaceType, ...spaceTypeColor };
        }
      );

      yield put(fetchProjectSpaceTypesSuccess(updatedProjectSpaceTypes));
    }
  } catch (e) {
    yield put(handleError(e));
  }
}

function* saveProjectYear(action: ReturnType<typeof actions.saveProjectYear>) {
  try {
    const project: IProject = yield select(selectCurrentProject);

    const { year } = action.payload;
    const projectResponse: APIResponse<typeof updateProjectApi> = yield call(
      updateProjectApi,
      {
        ...project,
        year,
      }
    );
    const currentScenario: PlainProgramScenario = yield select(
      selectCurrentScenario
    );

    const updatedProject = camelize(projectResponse.data.updatedProject);

    yield put(updateProjectYear(updatedProject.year));
    yield put(getProjectScenarios(project.id));

    if (currentScenario && ProgramScenario.usesTargetYear(currentScenario)) {
      const currentScenarioIsNotSavedYet = !currentScenario.id;
      if (currentScenarioIsNotSavedYet) {
        yield put(
          buildNewScenario(currentScenario.calculatorType, {
            shouldMergeWithCurrentScenario: true,
          })
        );
        return;
      }
      yield take(GET_SCENARIOS_SUCCESS);
      const updatedScenarios: PlainProgramScenario[] = yield select(
        selectScenarios
      );
      const currentScenarioWithYearUpdated = updatedScenarios.find(
        (s) => s.id === currentScenario.id
      );
      const tempScenario: PlainProgramScenario = yield select(
        selectTemporaryScenario
      );
      const isEditModeEnabled = !!tempScenario;
      if (isEditModeEnabled) {
        yield put(setTemporaryScenario(currentScenarioWithYearUpdated));
        const changesWithYearUpdateMerge: Scenario = {
          ...ProgramScenario.toAPIScenario(currentScenario),
          targetYear: currentScenarioWithYearUpdated.targetYear,
          startYear: currentScenarioWithYearUpdated.startYear,
          endYear: currentScenarioWithYearUpdated.endYear,
        };
        yield put(setCurrentScenario(changesWithYearUpdateMerge));
      } else {
        yield put(setCurrentScenario(currentScenarioWithYearUpdated));
      }
    }
  } catch (e) {
    yield put(handleError(e));
  }
}

function* getUserFavoriteProjectsLegacy(
  action: ReturnType<typeof actions.getUserFavoriteProjectsLegacy>
) {
  try {
    const { type } = action.payload;
    const { data } = yield call(fetchUserFavoriteProjectsApi, type);
    const userFavoriteProjectsLegacy = data?.userFavoriteProjectsLegacy;
    yield put(
      getUserFavoriteProjectsLegacySucceeded(userFavoriteProjectsLegacy)
    );
  } catch (e) {
    yield put(handleError(e));
  }
}

function* createUserFavoriteProject(
  action: ReturnType<typeof actions.createUserFavoriteProject>
) {
  try {
    const {
      projectId,
      onSuccess,
      shouldRefreshProjectsAfterwards,
    } = action.payload;
    yield call(createUserFavoriteProjectApi, projectId);
    const currentProject: IProject = yield select(selectCurrentProject);
    const projectType: string = yield select(
      (state: IAppState) => state.projectsReducer.currentProjectType
    );
    if (currentProject?.id === projectId)
      yield put(
        setCurrentProject({ ...currentProject, isMarkedAsFavoriteByUser: true })
      );
    yield put(actions.createUserFavoriteProjectSucceeded({ projectId }));
    yield put(
      showToastMessage({
        status: 'success',
        text: 'The project has been added to your favorites!',
      })
    );
    if (shouldRefreshProjectsAfterwards)
      yield put(getUserFavoriteProjectsLegacyAction(projectType));

    if (onSuccess) yield call(onSuccess);
  } catch (e) {
    yield put(handleError(e));
  }
}

function* deleteUserFavoriteProjectLegacy(
  action: ReturnType<typeof actions.deleteUserFavoriteProjectLegacy>
) {
  try {
    const { userFavoriteProjectId } = action.payload;
    yield call(deleteUserFavoriteProjectApi, { userFavoriteProjectId });
    const projectType: string = yield select(
      (state: IAppState) => state.projectsReducer.currentProjectType
    );
    yield put(getUserFavoriteProjectsLegacyAction(projectType));
  } catch (e) {
    yield put(handleError(e));
  }
}

function* deleteUserFavoriteProject(
  action: ReturnType<typeof actions.deleteUserFavoriteProject>
) {
  try {
    const { projectId, onSuccess } = action.payload;
    yield call(deleteUserFavoriteProjectApi, { projectId });
    const currentProject: IProject = yield select(selectCurrentProject);
    if (currentProject?.id === projectId)
      yield put(
        setCurrentProject({
          ...currentProject,
          isMarkedAsFavoriteByUser: false,
        })
      );
    yield put(actions.deleteUserFavoriteProjectSucceeded({ projectId }));
    if (onSuccess) yield call(onSuccess);
  } catch (e) {
    yield put(handleError(e));
  }
}

function* getOrganizationUsers(
  action: ReturnType<typeof actions.getOrganizationUsers>
) {
  try {
    const { organizationId } = action.payload;
    const { data } = yield call(getUsersByOrganizationApi, organizationId);
    const users = data?.users;
    yield put(getOrganizationUsersSucceeded(users));
  } catch (e) {
    yield put(handleError(e));
  }
}

function* joinCurrentProject() {
  try {
    const project: IProject = yield select(selectCurrentProject);
    const response: APIResponse<typeof joinProjectApi> = yield call(
      joinProjectApi,
      project.id
    );
    const {
      currentUserRole: currentUserRoleInProject,
      id: projectId,
    }: IProject = yield select(selectCurrentProject);

    if (response.data.projectEditor.userId) {
      yield put(
        getProjectEditors({
          projectId,
          perPage: 999,
          sort: { nameOwnerFirst: 'ASC' },
        })
      ); // needed to know if org admin joined the project
      yield put(
        actions.joinCurrentProjectSucceeded(
          currentUserRoleInProject === UserRoleInProject.viewer
            ? UserRoleInProject.editor
            : currentUserRoleInProject
        )
      );
      yield put(
        showToastMessage({
          status: 'success',
          text: 'Welcome to the project!',
        })
      );
    } else {
      throw new Error(
        `joinTeam API call returned an invalid response, projectId= ${project.id}`
      );
    }
  } catch (e) {
    yield put(actions.joinCurrentProjectFailed());
    yield put(handleError(e));
    yield put(
      showToastMessage({
        status: 'error',
        text: STANDARD_ERROR_MESSAGE,
      })
    );
  }
}

function* joinProject(action: ReturnType<typeof actions.joinProject>) {
  try {
    const response: APIResponse<typeof joinProjectApi> = yield call(
      joinProjectApi,
      action.payload.id
    );

    if (response.data.projectEditor.userId) {
      yield put(actions.joinProjectSucceeded(action.payload.id));
      yield put(
        showToastMessage({
          status: 'success',
          text: 'Welcome to the project!',
        })
      );
    } else {
      throw new Error(
        `joinTeam API call returned an invalid response, projectId= ${action.payload.id}`
      );
    }
  } catch (e) {
    yield put(actions.joinProjectFailed());
    yield put(handleError(e));
    yield put(
      showToastMessage({
        status: 'error',
        text: STANDARD_ERROR_MESSAGE,
      })
    );
  }
}

function* issueRequestToJoinProjectCall(
  action: ReturnType<typeof issueRequestToJoinProject>
) {
  try {
    yield call(issueRequestToJoinProjectApi, action.payload.id);

    yield put(actions.issueRequestToJoinProjectSucceeded());

    if (action.payload.getPendingRequestsOfAllProjects) {
      yield put(getUserPendingProjectRequests());
    } else {
      yield put(getUserPendingProjectRequests(action.payload.id));
    }

    yield put(
      showToastMessage({
        status: 'success',
        text: 'Request sent!',
      })
    );
  } catch (e) {
    yield put(actions.issueRequestToJoinProjectFailed());
    yield put(handleError(e));
    yield put(
      showToastMessage({
        status: 'error',
        text: STANDARD_ERROR_MESSAGE,
      })
    );
  }
}

function* getProjectEditorsCall(
  action: ReturnType<typeof actions.getProjectEditors>
) {
  try {
    const response: APIResponse<typeof getProjectEditorsApi> = yield call(
      getProjectEditorsApi,
      action.payload
    );
    yield put(
      actions.getProjectEditorsSucceeded({
        projectEditors: response.data.results.users,
        total: response.data.results.total,
      })
    );
  } catch (e) {
    yield put(actions.getProjectEditorsFailed());
    yield put(
      showToastMessage({
        status: 'error',
        text: STANDARD_ERROR_MESSAGE,
      })
    );
  }
}

function* removeProjectEditorCall(
  action: ReturnType<typeof actions.removeProjectEditor>
) {
  try {
    const { userId, projectId, onSuccess } = action.payload;
    yield call(removeProjectEditor, { userId, projectId });
    yield put(actions.removeProjectEditorSucceeded(action.payload.userId));
    const currentUser: IUser = yield select(selectCurrentUser);
    const currentProject: IProject = yield select(selectCurrentProject);
    const isUserSelfRemoval = currentUser.id === userId;
    if (
      isUserSelfRemoval &&
      currentProject.currentUserRole !== UserRoleInProject.orgAdmin
    )
      yield put(
        setCurrentProject({
          ...currentProject,
          currentUserRole: UserRoleInProject.viewer,
        })
      );
    if (onSuccess) onSuccess();
  } catch (e) {
    yield put(actions.removeProjectEditorFailed());
    yield put(
      showToastMessage({
        status: 'error',
        text: STANDARD_ERROR_MESSAGE,
      })
    );
  }
}

function* addTeamsToProjectCall(action: ReturnType<typeof addTeamsToProject>) {
  try {
    const { teamIds, projectId, onAddTeamsSucceded } = action.payload;
    for (let i = 0; i < teamIds.length; i++) {
      yield call(addTeamToProject, teamIds[i], projectId);
    }
    if (onAddTeamsSucceded) onAddTeamsSucceded();
    yield put(getTeamsForProject({ projectId, sort: { name: 'ASC' } }));
  } catch (e) {
    yield put(
      showToastMessage({
        status: 'error',
        text: e.message || STANDARD_ERROR_MESSAGE,
      })
    );
  }
}

function* removeTeamFromProjectCall(
  action: ReturnType<typeof actions.removeTeamFromProject>
) {
  try {
    const { teamId, projectId, onRemoveTeamSucceeded } = action.payload;
    yield call(removeTeamFromProject, teamId, projectId);
    if (onRemoveTeamSucceeded) onRemoveTeamSucceeded();
    yield put(getTeamsForProject({ projectId, sort: { name: 'ASC' } }));
  } catch (e) {
    yield put(
      showToastMessage({
        status: 'error',
        text: e.message || STANDARD_ERROR_MESSAGE,
      })
    );
  }
}

function* addProjectEditorsCall(
  action: ReturnType<typeof actions.addProjectEditors>
) {
  try {
    const { userIds, projectId, onSuccess } = action.payload;
    for (let i = 0; i < userIds.length; i++) {
      yield call(addProjectEditor, { userId: userIds[i], projectId });
    }
    yield put(
      actions.getProjectEditors({
        projectId,
        perPage: 999,
        page: 1,
        sort: { nameOwnerFirst: 'ASC' },
      })
    );
    if (onSuccess) onSuccess();
  } catch (e) {
    // Avoid sending sentry exceptions for this error
    if (!e.message || e?.message?.indexOf('already an editor') === -1)
      yield put(handleError(e));
    yield put(
      showToastMessage({
        status: 'error',
        text: e.message || STANDARD_ERROR_MESSAGE,
      })
    );
  }
}

function* transferProjectOwnershipCall(
  action: ReturnType<typeof actions.transferProjectOwnership>
) {
  try {
    const { onSuccess, user, projectId, ...payload } = action.payload;
    yield call(transferProjectOwnership, {
      userId: user.id,
      projectId,
      ...payload,
    });
    if (onSuccess) onSuccess();
    yield put(
      actions.transferProjectOwnershipSucceeded({
        projectId: action.payload.projectId,
        user,
        preservePreviousOwnerAsEditor: payload.preservePreviousOwnerAsEditor,
      })
    );
  } catch (e) {
    yield put(handleError(e));
    yield put(
      showToastMessage({
        status: 'error',
        text: STANDARD_ERROR_MESSAGE,
      })
    );
  }
}

function* leaveProjectCall(action: ReturnType<typeof actions.leaveProject>) {
  try {
    const { onSuccess, ...payload } = action.payload;
    yield call(leaveProject, payload);
    if (onSuccess) onSuccess();
    yield put(actions.leaveProjectSucceeded(payload.projectId));
  } catch (e) {
    yield put(handleError(e));
    yield put(
      showToastMessage({
        status: 'error',
        text: STANDARD_ERROR_MESSAGE,
      })
    );
  }
}

function* recordProjectActivity(
  action: ReturnType<typeof actions.recordProjectActivity>
) {
  try {
    const { projectId } = action.payload;

    const { data }: APIResponse<typeof recordProjectActivityApi> = yield call(
      recordProjectActivityApi,
      projectId
    );

    if (!data.success) {
      throw new Error('Could not record project activity');
    }
  } catch (e) {
    yield put(handleError(e));
  }
}

function* updateLastEditorWithCurrentUserCall() {
  const currentProject: IProject = yield select(selectCurrentProject);
  const currentUser: IUser = yield select(selectCurrentUser);

  yield put(
    setCurrentProject({
      ...currentProject,
      lastEditor: currentUser,
      updatedAt: moment().format(),
    })
  );
}

function* updateHeadcounts(
  action: ReturnType<typeof actions.updateHeadcounts>
) {
  const { headcounts, level } = action.payload;
  const response: { data: { headcounts: Headcount[] } } = yield call(
    headcountApi.updateHeadcounts,
    headcounts
  );

  const { headcounts: updatedHeadcounts } = response.data;

  const currentProject: IProject = yield select(selectCurrentProject);
  const buildings = [...currentProject.buildings];

  let newProject = currentProject;

  const projectFloors: {
    [key: number]: IFloor & { buildingId: number };
  } = currentProject.buildings.reduce((floorsMap, building) => {
    return {
      ...floorsMap,
      ...building.floors.reduce((buildingFloors, floor) => {
        return {
          ...buildingFloors,
          [floor.id]: { ...floor, buildingId: building.id },
        };
      }, {}),
    };
  }, {});

  const buildingIndexes: { [key: number]: number } = buildingIndexesById(
    buildings
  );

  if (level === buildingLevel) {
    updatedHeadcounts.forEach((headcount: Headcount) => {
      const buildingIndex =
        buildingIndexes[parseInt(headcount.buildingId as string, 10)];

      const building = buildings[buildingIndex];
      const buildingFloors = building.floors.map((floor: IFloor) => ({
        ...floor,
        headcount: {
          architect: null,
          client: null,
        },
      }));

      if (buildingIndex >= 0) {
        buildings[buildingIndex] = {
          ...building,
          headcount,
          floors: buildingFloors,
        };
      }
    });
  } else if (level === floorLevel) {
    updatedHeadcounts.forEach((headcount: Headcount) => {
      const floor = projectFloors[parseInt(headcount.floorId as string, 10)];
      const buildingIndex = buildingIndexes[floor.buildingId];
      const buildingFloors = [...buildings[buildingIndex].floors];
      const floorIndex = buildingFloors.findIndex(
        (buildingFloor) => buildingFloor.id === floor.id
      );

      buildingFloors[floorIndex] = {
        ...buildingFloors[floorIndex],
        headcount,
      };

      buildings[buildingIndex] = {
        ...buildings[buildingIndex],
        floors: buildingFloors,
        headcount: {
          architect: null,
          client: null,
        },
      };
    });
  }

  newProject = {
    ...currentProject,
    buildings,
  };

  yield put(setCurrentProject(newProject));
}

function* updateProjectHeadcountTypeCall(
  action: ReturnType<typeof actions.updateProjectHeadcountType>
) {
  try {
    const project: IProject = yield select(selectCurrentProject);
    const { headcountType } = action.payload;

    yield call(updateProjectApi, {
      ...project,
      headcountType,
    });
    yield put(setCurrentProject({ ...project, headcountType }));
  } catch (e) {
    yield put(handleError(e));
  }
}

function* saga() {
  yield all([
    takeLatest(SAVE_PROJECT, saveProjectCall),
    takeLatest(GET_PROJECTS, getProjects),
    takeLatest(REFRESH_CURRENT_PROJECT, refreshCurrentProjectCall),
    takeLatest(GET_PROJECT_INFO_BY_ID, getProjectById),
    takeLatest(GET_SPACE_TYPE_CATEGORIES, getSpaceTypeCategories),
    takeLatest(SAVE_BUILDING, saveBuilding),
    takeLatest(UPDATE_BUILDING_FLOOR, updateBuildingFloor),
    takeLatest(DELETE_BUILDING_FLOOR, deleteBuildingFloor),
    takeLatest(INSERT_FLOOR_ABOVE, insertFloorAbove),
    takeLatest(INSERT_FLOOR_BELOW, insertFloorBelow),
    takeLatest(MOVE_FLOOR_UP, moveFloorUp),
    takeLatest(MOVE_FLOOR_DOWN, moveFloorDown),
    takeLatest(SAVE_EDITING_BUILDING, saveEditingBuilding),
    takeLatest(SAVE_DEPARTMENT, createDepartment),
    takeLatest(DELETE_DEPARTMENT, deleteDepartment),
    takeLatest(GET_DEPARTMENTS_BY_PROJECT_ID, getDepartmentsByProjectId),
    takeLatest(UPDATE_DEPARTMENT, updateDepartment),
    takeLatest(UPDATE_DEPARTMENTS, updateDepartments),
    takeLatest(ARCHIVE_PROJECT, archiveProject),
    takeLatest(CLONE_PROJECT, cloneProject),
    takeLatest(DELETE_BUILDING, deleteBuilding),
    takeLatest(BULK_UPDATE_BUILDING_INDICES, bulkUpdateBuildingIndices),
    takeLatest(FETCH_PROJECT_COLORS, fetchProjectColors),
    takeLatest(SET_PROJECT_COLOR, setProjectColors),
    takeLatest(UPDATE_PROJECT_COLORS, updateProjectColors),
    takeLatest(SAVE_PROJECT_YEAR, saveProjectYear),
    takeLatest(
      GET_USER_FAVORITE_PROJECTS_LEGACY,
      getUserFavoriteProjectsLegacy
    ),
    takeLatest(
      DELETE_USER_FAVORITE_PROJECT_LEGACY,
      deleteUserFavoriteProjectLegacy
    ),
    takeLatest(DELETE_USER_FAVORITE_PROJECT, deleteUserFavoriteProject),
    takeLatest(CREATE_USER_FAVORITE_PROJECT, createUserFavoriteProject),
    takeLatest(GET_ORGANIZATION_USERS, getOrganizationUsers),
    takeLatest(JOIN_CURRENT_PROJECT, joinCurrentProject),
    takeLatest(JOIN_PROJECT, joinProject),
    takeLatest(ISSUE_REQUEST_TO_JOIN_PROJECT, issueRequestToJoinProjectCall),
    takeLatest(GET_PROJECT_EDITORS, getProjectEditorsCall),
    takeLatest(REMOVE_PROJECT_EDITOR, removeProjectEditorCall),
    takeLatest(ADD_TEAMS_TO_PROJECT, addTeamsToProjectCall),
    takeLatest(ADD_PROJECT_EDITORS, addProjectEditorsCall),
    takeLatest(TRANSFER_PROJECT_OWNERSHIP, transferProjectOwnershipCall),
    takeLatest(LEAVE_PROJECT, leaveProjectCall),
    takeLatest(REMOVE_TEAM_FROM_PROJECT, removeTeamFromProjectCall),
    takeLatest(RECORD_PROJECT_ACTIVITY, recordProjectActivity),
    takeLatest(
      UPDATE_LAST_EDITOR_WITH_CURRENT_USER,
      updateLastEditorWithCurrentUserCall
    ),
    takeLatest(UPDATE_HEADCOUNTS, updateHeadcounts),
    takeLatest(UPDATE_PROJECT_HEADCOUNT_TYPE, updateProjectHeadcountTypeCall),
  ]);
}

export default saga;
